<div class="modal">
  <div class="row" class="modal-content">
    <div class="modal-main-wrapper">
      <div class="close-container">
        <div class="img-container">
          <img src="../../../assets/icons/Close.svg" alt="close icon" (click)="onClose()">
        </div>
      </div>
      <div class="content-wrapper">
        <img src="../../../assets/icons/icon-information.svg" alt="info"  class="icon" />
        <div class="message">{{"sessionExpireMessage" | transloco}}</div>
        <div class="time description"> {{time  | date:'m:ss': 'UTC'}}</div>     
      </div>
      <footer>
        <div class="button-wrapper">
          <button id="confirm-buttom-confirm-popup" class="action-btn white-text" (click)="onNo()">{{"Stay" |
            transloco}}</button>
          <button id="no-button-confirm-popup" class="action-btn white-text" (click)="onYes()">{{"Logout" |
            transloco}}</button>
        </div>
      </footer>
    </div>
  </div>
</div>